import { Table, Button } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import React from 'react';
import {
  OrderHistoryResponse,
  OrderHistoryItem
} from '../../../../../core-module/services/logistics/types';
import { OrderHistoryItemComponent } from './OrderHistoryItemComponent';

interface Props {
  readonly orderHistory: OrderHistoryResponse;
  readonly editableOrderIds: number[];
  readonly onEditClick: (existingOrder: OrderHistoryItem) => void;
}

const OrderHistoryComponent: React.FC<Props> = ({
  orderHistory,
  editableOrderIds,
  onEditClick
}) => {
  const columns: ColumnProps<OrderHistoryItem>[] = [
    {
      title: 'Week',
      dataIndex: 'week',
      key: 'week'
    },
    {
      title: 'Maaltijden',
      dataIndex: '',
      key: 'dishes',
      render: (_, rowData) => <OrderHistoryItemComponent item={rowData} />
    },
    {
      title: 'Acties',
      dataIndex: '',
      key: 'actions',
      width: '100px',
      render: (_, rowData) => {
        return editableOrderIds.includes(rowData.order_id) ? (
          <Button
            onClick={() => onEditClick(rowData)}
            type='primary'
            htmlType='button'
            icon='edit'
          ></Button>
        ) : undefined;
      }
    }
  ];

  return (
    <Table
      rowKey={(row, index) => index.toString()}
      rowClassName={() => 'striped-table-row'}
      bordered={true}
      size='small'
      columns={columns}
      dataSource={orderHistory}
      pagination={false}
      locale={{ emptyText: 'Geen data beschikbaar' }}
    />
  );
};

export { OrderHistoryComponent };
